module.exports = __webpack_public_path__ + "media/images/icon/ico_top_flow03-177330eb1e3858ce911b1f770b5540b6.svg";